import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getPage } from "../../store/root/reducer";
import CustomAppBar from "../layout/CustomAppBar";
import DataArchive from "../layout/DataArchive";
import PhotosArchive from "../layout/PhotosArchive";
import { verifyToken } from "../api/api";

export default function ArchiveDataPage({ handleLogout }: any) {
  let navigate = useNavigate();
  let location = useLocation();
  const page = useSelector(getPage);

  // verifyToken()
  //   .then()
  //   .catch(() => {
  //     logout();
  //   });

  const logout = () => {
    handleLogout();
    navigate("/", { replace: true });
  };

  return (
    <div className="relative flex flex-col h-full w-full">
      <div className="flex w-full h-1-10 z-1 bg-primary">
        <CustomAppBar handleLogout={logout} />
      </div>
      <Typography
        variant="h3"
        component="div"
        sx={{
          justifyContent: "flex-start",
          padding: "4px",
          width: "100%",
          color: "white",
        }}
        className="bg-primary h-1-10 flex align-center"
      >
        {"Data Archive"}
      </Typography>
      <Divider />
      <div className="relative flex h-8-10 w-full flex-col bg-primary">
        <DataArchive />
      </div>
    </div>
  );
}
